import { Component, EventEmitter, OnInit, Output, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IPeriod } from 'src/app/_models/period.vm';
import { ApiService } from 'src/app/_services/api.service';
import { SessionService } from 'src/app/_services/session.service';
import { StatusService } from 'src/app/_services/status.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { trackByPeriodId } from '../utils/track-by';
import { ErrorReportingService } from '../../_services/error-reporting.service';

@Component({
    selector: 'app-select-period',
    templateUrl: './select-period.component.html',
    styleUrls: ['./select-period.component.scss'],
    providers: [ApiService, SessionService],
    standalone: false
})
export class SelectPeriodComponent implements OnInit {
  private readonly errorReporting = inject(ErrorReportingService);

  public readonly trackByPeriodId = trackByPeriodId;

  // Ties every subscription below to this component's lifetime, so a response
  // that arrives after the user has navigated away is dropped instead of
  // writing into a view that no longer exists.
  private readonly destroyRef = inject(DestroyRef);


  @Output() public currentPeriod = new EventEmitter<IPeriod>();

  public periods: Array<IPeriod>;
  public periodSelected: IPeriod;

  public showPeriodChange: boolean = false;
  public explorerData: number = 1;

  constructor(
    private apiService: ApiService,
    private sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    private statusService: StatusService
  ) { }

  ngOnInit() {
    this.paramAndSessionCheck();
    this.statusService.showingChangeArea.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((status) => {
      this.showPeriodChange = status;
    });
  }

  paramAndSessionCheck() {

    let savedPeriodId: number = null;

    // Check sessionStorage
    let session = JSON.parse(sessionStorage.getItem('cvdpPeriod'));
    if (session) {
      savedPeriodId = session.TimePeriodID;
    }

    // Check query params
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => { 
      params.period ? savedPeriodId = +params.period : null;
    });

    // Get periods
    this.getPeriods(savedPeriodId);
  }

  getPeriods(periodId: number): void {
    this.apiService.getPeriods(this.explorerData).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      success => {
        this.periods = success.timePeriodList;
        this.selectPeriod(periodId ? periodId : this.periods[0].TimePeriodID);
      },
      error => {
        this.errorReporting.report('Get periods', error);
      }
    )
  }

  selectPeriod(periodId: number): void {

    // Select period
    let periodIndex = this.periods.findIndex(period => period.TimePeriodID == periodId);
    this.periodSelected = this.periods[periodIndex > -1 ? periodIndex : 0];

    // Save to session
    this.sessionService.setSessionStorage('cvdpPeriod', this.periodSelected);

    // Add to route
    this.router.navigate([], { queryParams: { period: this.periodSelected.TimePeriodID }, queryParamsHandling: 'merge' })
    
    // Emit to parent
    this.currentPeriod.emit(this.periodSelected);

  }

}
